import StartButton from "../components/Buttons/StartButton";
import HowManyOfThemButton from "../components/Buttons/HowManyOfThemButton";
import PremiumButton from "../components/Buttons/PremiumButton";
import React from "react";

const startBtn = (link) => <StartButton link={link} />
const howManyOfThemBtn = (link) => <HowManyOfThemButton link={link} />
const premiumBtn = (link) => <PremiumButton link={link} />

export const allButtons = {
  standard: startBtn,
  data: howManyOfThemBtn,
  premium: premiumBtn,
}
